export class ImportModel {
  clientId: number;
  importQuestion: boolean;
  importResponse: boolean;
  masterId: string;
  listVersion: any[];
  override = false;
  workspaceName: string;
  permission: string;
  userIds: number[];
  isSkipValidate: boolean;
  surveyId: number;
}



// WEBPACK FOOTER //
// ./src/app/models/typeform/import.model.ts